<ng-container [formGroup]="form">
    <fieldset 
        [ngClass]="fieldsetModifierClassnames ? fieldsetModifierClassnames : '_mb-4'">
        <label 
            *ngIf="label"
            [for]="fieldId"
            class="_inline-block _relative _ml-2 _mb-1"
            [class._required-field]="required"
            [ngClass]="darkTheme ? '_text-white' : '_text-black'">
            {{label}}
        </label>
        <input 
            [id]="fieldId"
            [formControlName]="fieldId"
            class="_input-squared _input-slim _px-2 _w-full"
            [class._input-invalid]="control.invalid && control.touched"
            [ngClass]="[
                darkTheme ? '_input-dark' : '',
                useMinWidth ? '_min-width-60' : '',
                inputModifierClassnames ? inputModifierClassnames : ''
            ]"
            [type]="numbersOnly ? 'number' : 'text'" 
            [placeholder]="placeholderText">
        <div *ngIf="control.invalid && control.touched" class="_text-error-red-light _text-sm _mt-1 _ml-2">
            <div *ngIf="control.errors?.required">Field is required</div>
            <div *ngIf="control.errors?.pattern">{{ punctuationAndSpecialCharactersAllowed ? 'Only letters, punctuation & special characters allowed' : 'Only letters allowed'}}</div>
            <div *ngIf="control.errors?.minlength?.actualLength < control.errors?.minlength?.requiredLength">Must be more than {{minLength}} letters</div>
        </div>
    </fieldset>
</ng-container>
